import React, { useEffect, useState } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import {
  Container,
  Typography,
  Input,
  Button,
  ErrorDialog,
} from "src/components";
import { useForm } from "react-hook-form";
import { IError } from "src/components/dialog/error";
import * as formValidators from "src/utils/form-validator";
import { localizationStrings } from "./constants";
import { passwordResetEmailState } from "../../recoil";
import { useRecoilState } from "recoil";
import { hideKeyboard } from "src/utils/event";
import { Auth } from "aws-amplify";
import LocalText from "src/local";

type Props = {
  onReset: () => void;
};

type FormValues = {
  email: string;
};

const Index: React.FC<Props> = (props) => {
  const [passowrdResetEmail, setPasswordResetEmail] = useRecoilState<string>(
    passwordResetEmailState
  );
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: { email: passowrdResetEmail },
  });
  const [error, setError] = useState<IError | null>(null);
  const [processed, setProcessed] = useState<boolean>(false);
  useEffect(() => {
    register("email", {
      validate: (value) => {
        if (!formValidators.RequireValidator(value)) {
          return localizationStrings.inputEmailValidationRequire;
        }
        if (!formValidators.EmailValidator(value)) {
          return localizationStrings.inputEmailValidationFormat;
        }
        return true;
      },
    });
  }, [register]);
  const onRequest = async (data: FormValues) => {
    //
    hideKeyboard();
    setProcessed(true);
    try {
      await Auth.forgotPassword(data.email);
      setPasswordResetEmail(data.email);
      setTimeout(() => {
        setProcessed(false);
        props.onReset();
      }, 500); // TODO: Rebild to better async flow
    } catch (e: any) {
      if (e.code === "NotAuthorizedException") {
        const authError = new Error(
          LocalText.screens.authPasswordReset.requestLayout.errorNotAuthorizedException
        );
        console.error(authError);
        setError(authError);
      } else if (e.code === "UserNotFoundException") {
        const authError = new Error(
          LocalText.screens.authPasswordReset.requestLayout.errorUserNotFoundException
        );
        console.error(authError);
        setError(authError);
      } else {
        console.error(e);
        setError(e as Error);
      }
      setProcessed(false);
    }
  };
  return (
    <Container style={styles.container} loading={processed}>
      <ScrollView>
        <Typography text={localizationStrings.label} variant={"section"} />
        <Input
          placeholder={localizationStrings.inputEmailPlaceholder}
          name={"email"}
          control={control}
          error={errors.email?.message}
          keyboardType={"email-address"}
          autoCapitalize={"none"}
        />
        <View style={styles.buttonContainer}>
          <Button
            title={localizationStrings.btnReset}
            loading={processed}
            onPress={handleSubmit(onRequest)}
          />
        </View>
      </ScrollView>
      {error ? (
        <ErrorDialog
          error={error}
          visible={true}
          onClose={() => setError(null)}
        />
      ) : null}
    </Container>
  );
};

const styles = StyleSheet.create({
  container: {},
  buttonContainer: {
    flexDirection: "column",
    marginTop: 36,
    marginHorizontal: 16,
  },
});

export default Index;
